/**
 * TASK-084 — react-query mutation hook for the unified review action endpoint.
 * Wraps `recordService.patchReview` and invalidates the affected caches on
 * success (record list, record detail, review queue).
 */
import { useMutation, useQueryClient } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
import { patchReview } from '../api/recordService';
export var useReviewMutation = function (recordId, options) {
    if (options === void 0) { options = {}; }
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    return useMutation(function (body) { return patchReview(ky, recordId, body); }, {
        onSuccess: function (result) {
            var _a;
            queryClient.invalidateQueries(['record', recordId]);
            queryClient.invalidateQueries(['records']);
            queryClient.invalidateQueries(['review-queue']);
            (_a = options.onSuccess) === null || _a === void 0 ? void 0 : _a.call(options, result);
        },
        onError: function (error) {
            var _a;
            (_a = options.onError) === null || _a === void 0 ? void 0 : _a.call(options, error);
        },
    });
};
